import { render } from "./orderForm.vue?vue&type=template&id=420c3db0"
import script from "./orderForm.vue?vue&type=script&lang=js"
export * from "./orderForm.vue?vue&type=script&lang=js"

import "./orderForm.vue?vue&type=style&index=0&id=420c3db0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__